<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'ApplicationList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
    </b-col>
    <b-col>
      <div class="card">
<!--        <div class="card-header">-->
<!--          <h4 class="card-title">{{$t('views.application.sqlScriptRun.title')}}</h4>-->
<!--        </div>-->
        <div class="card-body">
          <div class="form-group">
            <label
              for="application_applicationType"
              class="form-control-label">{{$t('views.application.form.applicationType')}}</label>
            <el-select
              id="application_applicationType"
              :class="['select-default']"
              placeholder=""
              filterable
              v-model="item.applicationType">
              <el-option v-for="option in applicationTypes"
                         class="select-default"
                         :value="option['@id']"
                         :label="option['title']"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label
              for="application_sqlScript"
              class="form-control-label">{{$t('views.application.form.sqlScript')}}</label>
            <b-form-textarea
            id="application_sqlScript"
            v-model="item.sqlScript"
            placeholder=""
            rows="8"
            ></b-form-textarea>
          </div>
          <div>
            <b-button @click="executeScript" variant="success">
              {{$t('buttons.submit')}}
            </b-button>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'SqlScriptRun',
  data () {
    return {
      item: {
        applicationType: undefined,
        sqlScript: ''
      },
      applicationTypes: []
    }
  },

  created () {
    this.getApplicationTypes()
  },

  methods: {
    executeScript () {
      this.$http
        .post('api/sql_script_executeds', this.item,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getApplicationTypes () {
      this.$http.get('api/application_types')
        .then(response => {
          this.applicationTypes = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    }
  }
}
</script>
